import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { BASE_URL } from '../apiConfig'

export const addPortalUsers = createAsyncThunk(
  'addPortalUsers',
  async ({ jwt_token, requestBody }) => {
    console.log('Request Body - ', requestBody)
    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + jwt_token
      },
      body: requestBody
    }

    try {
      const response = await fetch(`${BASE_URL}admin/add/user/`, options)
      console.log('Request Options - ', options)
      console.log('REsponse -- ', response)
      return response.data
    } catch (error) {
      console.log('Error', error.response.data)
      alert(error.response.data.message)
      throw error.response.data
    }
  }
)

const addPortalUsersSlice = createSlice({
  name: 'addPortalUsers',
  initialState: {
    isLoading: false,
    data: null,
    isError: false,
    errorMessage: null
  },
  reducers: {},
  extraReducers: builder => {
    builder.addCase(addPortalUsers.pending, state => {
      state.isLoading = true
      state.isError = false
      state.errorMessage = null
    })
    builder.addCase(addPortalUsers.fulfilled, (state, action) => {
      state.isLoading = false
      state.data = action.payload
      state.isError = false
      state.errorMessage = null
    })
    builder.addCase(addPortalUsers.rejected, (state, action) => {
      state.isLoading = false
      state.isError = true
      state.errorMessage = action.error.message
    })
  }
})

export default addPortalUsersSlice.reducer
